import { FC, useState } from "react";
// @ts-ignore
import Modal from "@/components/Common/Modal/Modal";
import closeIcon from "@/assets/imgs/gamblingModalCloseIcon.png";

import "./index.less";
import { Toast } from "codoon-come";

const PREFIX = "info-modal";

interface IValue {
  required: boolean;
  title: string;
  placeholder: string;
  input_type: string;
  value: string;
}

interface IProps {
  visible: boolean;
  value?: IValue;
  onSubmit?: (value: IValue) => void;
  onSkip?: () => void;

  onClose: () => void;
}

const InfoModal: FC<IProps> = ({
  visible,
  value,
  onSubmit,
  onSkip,
  onClose,
}) => {
  const [text, setText] = useState(value?.value);

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      animation={"fade"}
      className={PREFIX}
    >
      <div className={`${PREFIX}_bodyClose`} onClick={onClose}>
        <img src={closeIcon} alt="close" />
      </div>
      <div className={`${PREFIX}_title`}>请填写报名信息</div>
      <div className={`${PREFIX}_field_title`}>{value?.title}</div>
      <input
        className={`${PREFIX}_field_value`}
        type="text"
        value={text}
        placeholder={value?.placeholder}
        onChange={(e) => {
          setText(e.target.value);
        }}
      />
      <div className={`${PREFIX}_btns`}>
        {!value?.required ? (
          <div className={`${PREFIX}_btn`} onClick={onSkip}>
            直接报名
          </div>
        ) : null}
        <div
          className={`${PREFIX}_btn ${PREFIX}_btn_confirm`}
          onClick={() => {
            if (!text) {
              Toast.showToast("请填写报名信息");
              return;
            }

            onSubmit?.({
              ...value!,
              value: text,
            });
          }}
        >
          提交信息
        </div>
      </div>
    </Modal>
  );
};

export default InfoModal;
